import apiClient from './apiClient';

// F111 原料主檔
export interface F111 {
  f111_01: string;   // 原料代號
  f111_11: string;   // 原料名稱 (中文)
  f111_12: string;   // 原料名稱 (英文)
  f111_13: string;   // 原料分類代號
  f111_21: string;   // 原料規格描述
  f111_22: number;   // 規格數值 (主)
  f111_221: number;  // 規格數值 (副)
  f111_23: string;   // 規格單位
  f111_24: number;   // 重量 (主)
  f111_241: number;  // 重量 (副)
  f111_25: string;   // 重量單位
  f111_26: string;   // 廠商料號
  f111_27: string;   // 建立人員
  f111_28: string | null;
  f111_29: string | null;
  f111_30: boolean;  // 啟用旗標
  f111_91: string;
  f111_92: string | null;
  f111_93: string;
}

export interface QueryRangeResponse {
  data: F111[];
  total: number;
  message?: string;
}

const BASE = '/api/material-report';

const materialReportApi = {
  queryRange(start: string, end: string): Promise<QueryRangeResponse> {
    const params = new URLSearchParams();
    if (start) params.set('start', start);
    if (end) params.set('end', end);
    return apiClient.get(`${BASE}/query?${params}`).then(r => r.data);
  },

  list(page = 1, size = 20, keyword = ''): Promise<{ data: F111[]; total: number; page: number; size: number }> {
    const params = new URLSearchParams({ page: String(page), size: String(size) });
    if (keyword) params.set('keyword', keyword);
    return apiClient.get(`${BASE}?${params}`).then(r => r.data);
  },
};

export default materialReportApi;
